export default function Breadcrumbs({ items = [], light = false, className = "" }) {
  const classes = ["page-breadcrumbs", light ? "page-breadcrumbs--light" : "", className]
    .filter(Boolean)
    .join(" ");

  return (
    <nav className={classes} aria-label="Breadcrumb">
      <ol>
        {items.map((item, index) => {
          const isCurrent = index === items.length - 1;
          return (
            <li key={`${item.label}-${index}`}>
              {index > 0 && <span aria-hidden="true">/</span>}
              {isCurrent || !item.href ? (
                <span aria-current={isCurrent ? "page" : undefined}>{item.label}</span>
              ) : (
                <a href={item.href}>{item.label}</a>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
